import React from 'react'

import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'

import { isMobile } from '../../utils'
import { styles } from './styles'

export const CheckEmail = () => {
  return (
    <main style={styles.main}>
      <Paper elevation={isMobile ? 0 : 1} square style={styles.paper}>
        <Typography id="titlePage" variant="h5">
          รีเซ็ตรหัสผ่าน
        </Typography>
        <div
          style={{
            marginTop: '1em'
          }}
        >
          <Typography component="p">กรุณาตรวจสอบอีเมลของคุณที่ลงทะเบียนไว้</Typography>
        </div>
        <div
          style={{
            marginTop: '1em'
          }}
        >
          <Button id="btnLogin" color="primary" fullWidth>
            <Link href="#" to="/" style={styles.link}>
              กลับสู่หน้าแรก
            </Link>
          </Button>
        </div>
      </Paper>
    </main>
  )
}

export default CheckEmail



// WEBPACK FOOTER //
// ./src/pages/CheckEmail/index.js